module.exports = __webpack_public_path__ + "img/btn_icon.9449ac86.svg";